module.exports = __webpack_public_path__ + "img/add_blue.678387c7.svg";